import { render, staticRenderFns } from "./CompanyUsers.vue?vue&type=template&id=10cd23de"
import script from "./CompanyUsers.vue?vue&type=script&lang=ts"
export * from "./CompanyUsers.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports